import React, { useState, useCallback } from "react";
import { AppRemixIcon } from "@/layout/AppComponents";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import colors from "../../../../../../constants/colors";
import { axiosPath } from "../../../../../../routing/helpers/router";
import * as currentPageAction from "../../../../../../store/actions/currentPageAction";
import AppSpinner from "../../../../../components/AppSpinner";
import Translator from "../../../../../components/helpers/Translator";
import useIsMounted from "../../../../../components/hooks/useIsMounted";
import errorHandler from '../../../../../components/error/ErrorHandler';

export default function UserMark(props) {
  const { taskID, isMouseOver } = props;
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const { moduleBridgeHex, view } = useParams();
  const userMarkTaskID = useSelector(
    (state) => state.currentPage?.options?.userMark
  );
  const [isLoading, setIsLoading] = useState(false);

  // > SET USERMARK
  const handleUserMark = useCallback(
    async (id) => {
      setIsLoading(true);
      axios
        .post(
          axiosPath(
            "api_r_user_module_correctiveActions_task_list_setUserMark"
          ),
          { moduleBridgeHex, taskID: id, view }
        )
        .then((r) => {
          if (isMounted.current) {
            setIsLoading(false);
            dispatch(
              currentPageAction.change("options", { userMark: r.data || null })
            );
          }
        })
        .catch((e) => {
          setIsLoading(false);
          dispatch(errorHandler(e));
        });
    },
    [moduleBridgeHex, view]
  );

  // < SET USERMARK

  if (isLoading) {
    return (
      <AppSpinner>
        <AppRemixIcon icon="loader-4" color={colors.primary} size={24} />
      </AppSpinner>
    );
  }

  return (
    <>
      {userMarkTaskID === taskID ? (
        <AppRemixIcon
          title={ReactDOMServer.renderToString(
            <Translator
              file="module-legalCompliance"
              name="obligation.unmark.position"
            />
          )}
          className="pointer"
          color={colors.danger}
          icon="map-pin-user"
          size={24}
          onClick={() => handleUserMark(null)}
        />
      ) : (
        <>
          {isMouseOver && (
            <AppRemixIcon
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-legalCompliance"
                  name="obligation.mark.position"
                />
              )}
              className="pointer"
              color={colors.grey400}
              icon="map-pin-user"
              size={24}
              onClick={() => handleUserMark(taskID)}
            />
          )}
        </>
      )}
    </>
  );
}
